import { createContext, useContext, useEffect, useState } from 'react';
import { resolveTreatments } from '../utils/laboratoryClient';
import { jsx as _jsx } from "react/jsx-runtime";
const ExperimentsContext = /*#__PURE__*/createContext(null);
export function ExperimentsProvider({
  children
}) {
  const [treatments, setTreatments] = useState(null);
  useEffect(() => {
    resolveTreatments().then(setTreatments).catch(() => {
      // Leave treatments null so consumers fall back to control.
    });
  }, []);
  return /*#__PURE__*/_jsx(ExperimentsContext.Provider, {
    value: treatments,
    children: children
  });
}
export function useExperiments() {
  return useContext(ExperimentsContext);
}